var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tooltip',{attrs:{"effect":"dark","placement":"top","content":_vm.tipMsg,"disabled":_vm.value == _vm.trueLabel}},[_c('div',{staticClass:"word-checkbox",class:[_vm.value == _vm.trueLabel ? 'active' : ''],on:{"click":_vm.handleCheck}},[_c('i',{class:[
          'iconfont',
          _vm.value == _vm.trueLabel ? 'icon-weixiao' : 'icon-weixiao1'
        ]}),(_vm.$slots.default)?_c('label',[_vm._t("default")],2):_vm._e()])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }